import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import { styled } from '@mui/material/styles';

import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Stack from '@mui/material/Stack';
import { Add } from "@mui/icons-material";
import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const EditWorkShopUser = (props) => {
    const history = useHistory();
    const [workShopUserImage, setWorkShopUserImage] = useState("");
    const eventid = localStorage.getItem('eventid')
    const [workShopUserEdit, setWorkShopUserEdit] = useState({
        name: "",
        email: "",
        password: "",
        phone: "",
        date: "",
        address: "",
        error_list: [],

    })
   
    useEffect(() => {
        const id = props.match.params.id;
        axios.get(`api/workshop-user-edit/${id}`).then((res) => {
            if (res.status === 200) {
                const wsueEdit = res.data.wsueData;
                setWorkShopUserEdit(wsueEdit);
            } else {
                swal('Error', 'Check API Something Wrong', 'error');
            }
        });
    }, [props.match.params.id]);

  

    const handleInput = (e) => {
        e.persist();
        setWorkShopUserEdit({ ...workShopUserEdit, [e.target.name]: e.target.value })
    }
    const abstractReviewer = (e) => {
        e.preventDefault();
       
        const data = {
            workShopUserImage,
            name: workShopUserEdit.name,
            email: workShopUserEdit.email,
            password: workShopUserEdit.password,
            phone: workShopUserEdit.phone,
            address: workShopUserEdit.address,
            
        }
        const id = props.match.params.id
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/workshop-user-update/${id}`, data, config).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');
                    //history.push('/admin/workshop/manage-user');
                    window.history.back();
                }
                else {
                    setWorkShopUserEdit({ ...workShopUserEdit, error_list: res.data.validate_error })
                }

            });
        });
    }
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
      });
      React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
          if (res.status === 200) {
            const getHomePageData = res.data.HomePageSetup;
            setAbstractHomeSetup(getHomePageData);
          }
        })
    
      }, [eventid]);
    
    
    
      let backGroundButtonByEvent = "";
      if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
      }
      else {
        backGroundButtonByEvent = '#145348'; // Default background color
      }
      //backgroundColor: backGroundButtonByEvent,


    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        backgroundColor: backGroundButtonByEvent,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={history.goBack} >
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Edit  User
                        </Typography>
                        <Box component="form" onSubmit={abstractReviewer} encType="multipart/form-data" noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Name"
                                        autoFocus
                                        name='name'
                                        onChange={handleInput} value={workShopUserEdit.name || ""} />
                                </Grid>


                                <Grid item xs={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        disabled
                                        id="email"
                                        label="Email Address"
                                        autoComplete="email"
                                        name='email'
                                        onChange={handleInput} value={workShopUserEdit.email || ""} />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        label="Phone"
                                        type="text"
                                        name='phone'
                                        onChange={handleInput} value={workShopUserEdit.phone || ""}
                                    />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Address"
                                        autoFocus
                                        name='address' onChange={handleInput} value={workShopUserEdit.address || ""} />
                                </Grid>
                                <Grid item xs={6} >
                                    <label htmlFor="icon-button-file">
                                        <TextField accept="image/*" id="icon-button-file" type="file" onChange={(e) => setWorkShopUserImage(e.target.files[0])} />
                                        <IconButton color="primary" aria-label="upload picture" component="span">
                                        </IconButton>
                                    </label>
                                </Grid>
                               
                               

                                {
                                    workShopUserEdit.image === "no_image.jpg" ? "" :
                                        <Grid item xs={6} >
                                            
                                            <img src={`${workShopUserEdit.base_url}/abstract/${workShopUserEdit.image}`} width="150" height="150" />
                                        </Grid>
                                }

                            </Grid>

                            <Grid container justifyContent="flex-end">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 5,  backgroundColor: backGroundButtonByEvent,}} >
                                    Update WorkShop User
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}


export default EditWorkShopUser;
